// extracted by mini-css-extract-plugin
export default {"video":"VideoViewer_video__mPsMG","error":"VideoViewer_error__cXgr5"};